const FEEDBACK_DOMAIN = 'feedback'

const FEEDBACK_KEY = {
  ALL: 'all',
  OPEN: 'open',
  IN_PROGRESS: 'inProgress',
  CLOSED: 'closed',
  DATA: 'data',
  CURRENT: 'current'
}

const FEEDBACK_PATH = {
  ALL: `${FEEDBACK_DOMAIN}.${FEEDBACK_KEY.ALL}`,
  ALL_DATA: `${FEEDBACK_DOMAIN}.${FEEDBACK_KEY.ALL}.data`,
  OPEN: `${FEEDBACK_DOMAIN}.${FEEDBACK_KEY.OPEN}`,
  OPEN_DATA: `${FEEDBACK_DOMAIN}.${FEEDBACK_KEY.OPEN}.data`,
  IN_PROGRESS: `${FEEDBACK_DOMAIN}.${FEEDBACK_KEY.IN_PROGRESS}`,
  IN_PROGRESS_DATA: `${FEEDBACK_DOMAIN}.${FEEDBACK_KEY.IN_PROGRESS}.data`,
  CLOSED: `${FEEDBACK_DOMAIN}.${FEEDBACK_KEY.CLOSED}`,
  CLOSED_DATA: `${FEEDBACK_DOMAIN}.${FEEDBACK_KEY.CLOSED}.data`,
  DATA: `${FEEDBACK_DOMAIN}.${FEEDBACK_KEY.DATA}`,
  CURRENT: `${FEEDBACK_DOMAIN}.${FEEDBACK_KEY.CURRENT}`
}

const FEEDBACK_STATE = {
  [FEEDBACK_KEY.ALL]: {
    data: [],
    status: null
  },
  [FEEDBACK_KEY.OPEN]: {
    data: [],
    status: null
  },
  [FEEDBACK_KEY.IN_PROGRESS]: {
    data: [],
    status: null
  },
  [FEEDBACK_KEY.CLOSED]: {
    data: [],
    status: null
  },
  [FEEDBACK_KEY.CURRENT]: null,
  [FEEDBACK_KEY.DATA]: {}
}

const FEEDBACK_ANALYTICS_EVENT = {
  CREATED: 'Feedback Created',
  CLOSED: 'Feedback Closed',
  LINK: 'Feedback Link',
  REPLY_ADDED: 'Feedback Reply Added',
  DELETED: 'Feedback Deleted'
}

const FEEDBACK_ACTION = {
  CREATE: 'FEEDBACK_CREATE',
  CLOSE: 'FEEDBACK_CLOSE',
  ADD_REPLY: 'FEEDBACK_ADD_REPLY',
  LOAD: 'FEEDBACK_LOAD',
  LOAD_BY_ID: 'FEEDBACK_LOAD_BY_ID',
  SAVE: 'FEEDBACK_SAVE',
  UPDATE_CURRENT: 'FEEDBACK_UPDATE_CURRENT',
  UPDATE_MESSAGE: 'FEEDBACK_UPDATE_MESSAGE',
  UPDATE_READ_AT: 'FEEDBACK_UPDATE_READ_AT',
  DELETE_CURRENT: 'FEEDBACK_DELETE_CURRENT',
  UPDATE: 'FEEDBACK_UPDATE',
  DELETE: 'FEEDBACK_DELETE'
}

const FEEDBACK_ENDPOINT = {
  FEEDBACK: '/feedback'
}

export {
  FEEDBACK_DOMAIN,
  FEEDBACK_KEY,
  FEEDBACK_PATH,
  FEEDBACK_STATE,
  FEEDBACK_ANALYTICS_EVENT,
  FEEDBACK_ACTION,
  FEEDBACK_ENDPOINT
}
